import { connect } from 'react-redux'
import Loadable from 'Components/LoadableToImported'

import { openRegisterModal } from 'Modules/modals/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'

import {
  removeCompareListing, clearAllCompareListing,
  updateAllCompareListing, toggleCompareGrid,
} from 'Modules/compare/actions'
// import CompareGrid from './CompareGrid'

export const MAX_COMPARE_LISTING_COUNT = 8

export const MIN_COMPARE_DESKTOP_WIDTH = 1024

export const COMPARE_GA_CATEGORY = 'ListingComparison'


const CompareGrid = Loadable({
  loader: () => import(/* webpackChunkName: "CompareGrid" */ './CompareGrid'),
  chunkName: 'CompareGrid',
})

const mapStateToProps = state => ({
  isAgentStickyBarVisible: state.app.isAgentStickyBarVisible,
  comparedListings: state.compare.comparedListings,
  isCompareGridOpen: state.compare.isCompareGridOpen,
  showCompareFullWarning: state.compare.showCompareFullWarning,
  userIsAuthentificated: state.userData.userIsAuthentificated,
})

const actions = {
  removeCompareListing,
  clearAllCompareListing,
  updateAllCompareListing,
  toggleCompareGrid,
  openRegisterModal,
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(CompareGrid)
